import { useState } from 'react'
import { PieImage } from 'components/common'
import { ContentModal } from 'components/organisms/modals/content-modal'

interface EventDateTimeWarningModalProps {
	open: boolean
	setOpen: (open: boolean) => void
	avatar?: string
	onChangeStartTime?: () => void
}

export function EventDateTimeWarningModal({
	open,
	setOpen,
	avatar,
	onChangeStartTime,
}: EventDateTimeWarningModalProps) {
	const handleChangeStartTime = () => {
		setOpen(false)
		onChangeStartTime?.()
	}

	return (
		<ContentModal open={open} setOpen={setOpen} isModal>
			<div className="relative flex flex-col items-center space-y-5">
				<div className="max-w-[304px]">
					<div>
						<h3 className="text-2xl font-medium mb-5 flex justify-center items-center gap-2">Oops...</h3>
						<div className="max-w-[269px] mx-auto">
							Looks like you have not completed your event before the start time.
						</div>
					</div>
					<div className="flex justify-center items-center py-8">
						<PieImage
							className="w-[200px] h-auto rounded-xl overflow-hidden flex-shrink-0"
							images={[avatar || '']}
						/>
					</div>
					<div className="max-w-[208px] mx-auto">
						Please set your start time on your reward to a future time.
					</div>
					<div className="mt-8 mb-6">
						<button
							type="button"
							className="px-6 rounded-3xl transition-all duration-300 bg-primary h-12 hover:bg-primary-hover disabled:bg-white-25 disabled:text-white-25 disabled:backdrop-blur-lg w-full font-bold"
							onClick={handleChangeStartTime}
						>
							Change Start Time
						</button>
					</div>
				</div>
			</div>
		</ContentModal>
	)
}

// ---------------------------------------------------------------------------
// Modal Manager integration
// ---------------------------------------------------------------------------

export interface EventDateTimeWarningModalManagedProps {
	avatar?: string
	onChangeStartTime?: () => void
}

declare module 'components/organisms/modals/modal-registry' {
	interface ModalRegistry {
		'event-datetime-warning': EventDateTimeWarningModalManagedProps
	}
}

export function ManagedEventDateTimeWarningModal({
	onClose,
	onChangeStartTime,
	...rest
}: EventDateTimeWarningModalManagedProps & { onClose: () => void }) {
	const [open, setOpen] = useState(true)

	const handleClose = () => {
		setOpen(false)
		setTimeout(onClose, 200)
	}

	return (
		<EventDateTimeWarningModal
			open={open}
			setOpen={(v: boolean) => { if (!v) handleClose() }}
			onChangeStartTime={() => { onChangeStartTime?.(); handleClose() }}
			{...rest}
		/>
	)
}
